module.exports = __webpack_public_path__ + "img/trazado2.eaf2b8dc.webp";